import {SellerType} from '../../../../../types/Seller';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';

const PRIVATE_SELLER_TYPE: SellerType = 'SELLERTYPE_PRIVATE_SELLER';

export function isPrivateSeller(car: ExtendedStatisticsCar | undefined) {
  return car?.seller?.type === PRIVATE_SELLER_TYPE;
}
